<template>
  <TableBodyRow
    :id="`saved-spots_table_row_${index}`"
    :thead="thead"
    class="gw_table_body_row_hoverable gw_hvr"
    :class="[
      {
        gw_table_body_row_dragged: draggedItems.some(i =>
          i ? i.public_id === item.public_id : false,
        ),
      },
    ]"
    @click="handleApplyClick('force')"
  >
    <TableBodyCell
      style="
        --max-width-td: 2.5rem;
        --min-width-td: 2.5rem;
        --padding-td: 0;
        justify-content: center;
      "
    >
      <div
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        <div
          :class="dragDisabled ? 'clr-black-4 icon_btn_disabled cursor-not-allowed' : 'cursor-grab'"
          class="mdi mdi-drag-vertical pa-1 csst csst_nm csst_active-hide-content icon_btn clr-grey"
        >
          <div
            class="csst_content clr-white text-nowrap"
            :style="dragDisabled ? `background:var(--clr-error)` : ''"
            style="line-height: 1.2; left: calc(100% + 0.5rem)"
            v-html="
              dragDisabled
                ? $t('tooltips.drag_drop_disable_enable_sort')
                : $t('tooltips.drill_drag_drop_change_order')
            "
          ></div>
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell
      style="
        --max-width-td: 2.5rem;
        --min-width-td: 2.5rem;
        --padding-td: 0;
        justify-content: center;
      "
      @click.stop
    >
      <Checkbox
        class="csst csst_nm flgmfslctr_title_controls_item"
        style="
          --icon-size: 1.25rem;
          --clr-disabled: var(--clr-grey-2);
          --clr-enabled: var(--clr-primary);
        "
        :value="isSelected"
        @click="$emit('toggle:selected')"
      >
        <template #content>
          <div
            class="csst_content text-nowrap clr-white"
            style="line-height: 1.2; left: calc(100% + 0.5rem)"
            v-html="$t('common.select')"
          />
        </template>
      </Checkbox>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.format"
      thKey="format"
    >
      <CustomFormatOption
        v-if="item.custom_solution"
        class="truncate"
        :customTree="item.custom_solution.custom_tree"
      />
      <GameFormatOption
        v-else
        class="truncate"
        :customItem="getGameformat(item)"
      />
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.board"
      thKey="board"
    >
      <div class="d-flex no-events">
        <div
          v-for="card in getCards(item.board || '')"
          :key="card + 'streets'"
          style="--height: 1.75em; --value-size-increase: 0.9"
          :class="`poker-card poker-card_mini card_${card[1]}`"
        >
          <div class="card-value">
            {{ card[0] }}
          </div>
        </div>
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.actions"
      thKey="actions"
    >
      <StreetActionsCompacted
        v-if="item.preflop_actions"
        :streets="getStreetsActions(item)"
      />
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.note"
      thKey="note"
    >
      <div
        class="truncate"
        style="max-width: 100%"
      >
        {{ item.note }}
      </div>
    </TableBodyCell>
    <TableBodyCell
      v-show="thead.tags"
      thKey="tags"
      @click.stop
    >
      <GwMenu
        placement="bottom-start"
        :flOptions="{ offset: 0, padding: 0 }"
        style="max-width: 100%"
        :ignoreDataGwmenu="true"
        @click.stop
      >
        <template #opener>
          <TagsTableCellList
            class="gw_btn_hover_back"
            :tags="item.tags"
            style="max-width: 100%"
          />
        </template>
        <template #default>
          <TagsManager
            data-gwmenu="noclose"
            style="box-shadow: var(--menu-shadow)"
            :inputAutofocus="!mobile"
            :tagIds="item.tags.map(t => t.id)"
            :tagType="tagType"
            :allTags="allTags"
            :hasAnyAll="false"
            @click:tag="tag => $emit('click:tag_item', tag)"
          />
        </template>
      </GwMenu>
    </TableBodyCell>
    <!-- v-show="thead.table_actions" -->
    <TableBodyCell
      thKey="table_actions"
      class="gw_table_body_cell_stickys gw_table_body_cell_sticky-noshadow"
      style="order: 99; --z-index-td-sticky-left: unset; --z-index-td-sticky-right: 0"
    >
      <div
        class="f-center h-100 ml-auto gw_hvr_content"
        style="right: 0.25rem; gap: 0.25rem"
      >
        <div
          class="gw_btn text-medium weight_500"
          @click.stop="$emit('open:detail')"
        >
          <div class="mdi mdi-pencil mr-1"></div>
          {{ $t('btn.edit') }}
        </div>
        <div
          class="gw_btn text-medium weight_500"
          @click.stop="handleApplyClick('force')"
        >
          <div class="mdi mdi-chevron-double-right mr-1"></div>
          {{ $t('btn.apply') }}
        </div>
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import Checkbox from '@/components/Common/Checkbox/Checkbox'
import TagsManager from '@/components/TagsManager/TagsManager'
import TagsTableCellList from '@/components/TagsManager/TagsTableCellList'
import GwMenu from '@/components/lib/GwMenu'
import CustomFormatOption from '@/components/GameFormat/CustomFormatOption'
import GameFormatOption from '@/components/GameFormat/GameFormatOption'
import StreetActionsCompacted from '@/components/StreetActionsCompacted/StreetActionsCompacted'
import { getGameformat } from '@/store/gameformat/gameformat'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'

import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import { SNK } from '@/helpers/helpers'

export default {
  name: 'SavedSpotsTableV1Row',
  components: {
    TableBodyRow,
    TableBodyCell,
    Checkbox,
    TagsManager,
    TagsTableCellList,
    GwMenu,
    CustomFormatOption,
    GameFormatOption,
    StreetActionsCompacted,
  },
  mixins: [table_mix, float_mix],
  props: {
    namespace: { required: true, default: '' },
    item: Object,
    index: Number,
    thead: Object,
    isSelected: Boolean,
    mobile: Boolean,
    allTags: Array,
    tagType: String,
    draggedItems: Array,
    dragDisabled: Boolean,
  },
  emits: ['toggle:selected', 'click:tag_item', 'open:detail', 'drag:start'],
  methods: {
    startDrag(e) {
      if (this.dragDisabled) return
      this.$emit('drag:start', e)
    },
    handleApplyClick(force) {
      if (force ? false : this.detailOpen) return

      this.$store.dispatch('router_rm_dialogs', {
        dialogs: ['cards-dialog', 'saved-spots-dialog'],
      })

      this.$store.dispatch('globals_action', 'disable_history_watcher')
      const link = this.getLink(this.item)

      setTimeout(() => {
        const { query } = link
        const { cussol_id } = query

        this.$store.dispatch(SNK('router_update_query', this.namespace), {
          query: {
            ...query,
          },
          push: true,
          replace: false,
          saveLocally: true,
        })
        if (cussol_id) {
          this.$store.dispatch(SNK('sol_studyInitializeNEW', this.namespace))
        } else {
          this.$store.dispatch('api_poker_history', { namespace: this.namespace })
        }

        setTimeout(() => {
          this.$store.dispatch('globals_action', 'enable_history_watcher')
        })
      })
    },
    getLink(item) {
      let gmfQuery = {}
      if (item.custom_solution?.id) {
        gmfQuery = {
          solution_type: 'custom',
          cussol_id: item.custom_solution.id,
        }
      } else {
        const { gameformats } = this.$store.getters
        const gameformat = getGameformat({ item, gameformats })
        gmfQuery = {
          solution_type: 'gwiz',
          gametype: gameformat.gametype,
          depth: gameformat.depth,
          stacks: gameformat.stacks,
        }
      }
      const res = {
        name: 'StudySolutions',
        query: {
          ...gmfQuery,
          preflop_actions: item.preflop_actions,
          flop_actions: item.flop_actions,
          turn_actions: item.turn_actions,
          river_actions: item.river_actions,
          history_spot: item.history_spot,
          board: item.board,
        },
      }
      // console.log(res)
      return res
    },
    getGameformat(item) {
      const { gameformats } = this.$store.getters
      const res = getGameformat({ item, gameformats })
      return res
    },
    getStreetsActions(item) {
      const res = {
        preflop_actions: item.preflop_actions ? item.preflop_actions.split('-') : [],
        flop_actions: item.flop_actions ? item.flop_actions.split('-') : [],
        turn_actions: item.turn_actions ? item.turn_actions.split('-') : [],
        river_actions: item.river_actions ? item.river_actions.split('-') : [],
      }
      return res
    },
  },
}
</script>
